__turbopack_context__.v({
  "hidden": "StickyTabsNavBar-module-scss-module__ktTUsG__hidden",
  "stickyTabsBar": "StickyTabsNavBar-module-scss-module__ktTUsG__stickyTabsBar",
  "stickyTabsBarSummary": "StickyTabsNavBar-module-scss-module__ktTUsG__stickyTabsBarSummary",
  "tabs": "StickyTabsNavBar-module-scss-module__ktTUsG__tabs",
});
